/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";

    const activeSamplingReport = async (page : any, pageSize: any, fromDate: any, toDate: any, location: any, batchCode: any, lotCode:any, plateSerielNo: any , sort : any , order:any,areaId: any, scheduleProductId: string, productId: string) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/air_sampling?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&batch_number=${batchCode}&lot_id=${lotCode}&serial_number=${plateSerielNo}&from_date=${fromDate}&to_date=${toDate}&area_master_id=${location}&area_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}&is_completed=`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };

    const passiveSamplingReport = async (page : any, pageSize: any, fromDate: any, toDate: any, location: any, batchCode: any, lotCode:any, plateSerielNo: any, sort : any , order:any,areaId: any, scheduleProductId: string, productId: string) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/passive_air_sampling?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&batch_number=${batchCode}&lot_id=${lotCode}&serial_number=${plateSerielNo}&from_date=${fromDate}&to_date=${toDate}&area_master_id=${location}&area_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}&is_completed=`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };
    const plateSamplingReport = async (page : any, pageSize: any, fromDate: any, toDate: any, location: any, batchCode: any, lotCode:any, plateSerielNo: any, sort : any , order:any,areaId: any, scheduleProductId: string, productId: string) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/plate_sampling?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&batch_number=${batchCode}&lot_id=${lotCode}&serial_number=${plateSerielNo}&from_date=${fromDate}&to_date=${toDate}&area_master_id=${location}&area_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}&is_completed=`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };
    const anaerobicReport = async (page : any, pageSize: any, fromDate: any, toDate: any, location: any, batchCode: any, lotCode:any, plateSerielNo: any, sort : any , order:any,areaId: any, scheduleProductId: string, productId: string) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/anaerobic_monitoring?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&batch_number=${batchCode}&lot_id=${lotCode}&serial_number=${plateSerielNo}&from_date=${fromDate}&to_date=${toDate}&area_master_id=${location}&area_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}&is_completed=`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };
    const nitrogenReport = async (page : any, pageSize: any, fromDate: any, toDate: any, location: any, batchCode: any, lotCode:any, plateSerielNo: any, sort : any , order:any,areaId: any, scheduleProductId: string, productId: string) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/nitrogen_monitoring?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&batch_number=${batchCode}&lot_id=${lotCode}&serial_number=${plateSerielNo}&from_date=${fromDate}&to_date=${toDate}&area_master_id=${location}&area_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}&is_completed=`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };
    const compressedAirReport = async (page : any, pageSize: any, fromDate: any, toDate: any, location: any, batchCode: any, lotCode:any, plateSerielNo: any, sort : any , order:any,areaId: any, scheduleProductId: string, productId: string) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/compressed_air_monitoring?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&batch_number=${batchCode}&lot_id=${lotCode}&serial_number=${plateSerielNo}&from_date=${fromDate}&to_date=${toDate}&area_master_id=${location}&area_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}&is_completed=`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };

    const personnelMonitoringReport = async (page : any, pageSize: any, fromDate: any, toDate: any, location: any, batchCode: any, lotCode:any, plateSerielNo: any, sort : any , order:any,areaId: any, scheduleProductId: string, productId: string) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/personal_monitoring?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&batch_number=${batchCode}&lot_id=${lotCode}&serial_number=${plateSerielNo}&from_date=${fromDate}&to_date=${toDate}&area_master_id=${location}&area_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}&is_completed=`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };

    const surfaceMonitoringReport = async (page : any, pageSize: any, fromDate: any, toDate: any, location: any, batchCode: any, lotCode:any, plateSerielNo: any, sort : any , order:any,areaId: any, scheduleProductId: string, productId: string) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/surface_monitoring_swab?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&batch_number=${batchCode}&lot_id=${lotCode}&serial_number=${plateSerielNo}&from_date=${fromDate}&to_date=${toDate}&area_master_id=${location}&area_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}&is_completed=`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };

    const surfaceMonitoringListReport = async (page : any, pageSize: any, fromDate: any, toDate: any, location: any, batchCode: any, lotCode:any, plateSerielNo: any, sort : any , order:any,areaId: any, scheduleProductId: string, productId: string) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/surface_monitoring?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&batch_number=${batchCode}&lot_code=${lotCode}&serial_number=${plateSerielNo}&from_date=${fromDate}&to_date=${toDate}&area_master_id=${location}&area_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}&is_completed=`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };

        const glovePortListReport = async (page : any, pageSize: any, fromDate: any, toDate: any, location: any, batchCode: any, lotCode:any, plateSerielNo: any, sort : any , order:any,areaId: any, scheduleProductId: string, productId: string) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/glove_monitoring?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&batch_number=${batchCode}&lot_code=${lotCode}&serial_number=${plateSerielNo}&from_date=${fromDate}&to_date=${toDate}&area_master_id=${location}&area_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}&is_completed=`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };

    const equipmentConfigurationReport = async (page : any, pageSize: any, fromDate: any, toDate: any, equipmentId: any, sort : any , order:any) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/equipment?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&equipment_id=${equipmentId}&from_date=${fromDate}&to_date=${toDate}`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };

    const plateActivityReport = async (page : any, pageSize: any, fromDate: any, toDate: any, locationId: any, userId: any, action: any, sort : any , order:any) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/plate_activity?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&location_id=${locationId}&user_id=${userId}&from_date=${fromDate}&to_date=${toDate}&action=${action}`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };

    const visualInspectionReport = async (page : any, pageSize: any, fromDate: any, toDate: any, operatorId: any, batchCode: any, lotCode:any, sort : any , order:any) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/visual_inspection?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&lot_id=${lotCode}&batch_code=${batchCode}&operator_id=${operatorId}&from_date_time=${fromDate}&to_date_time=${toDate}`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };

    const deviationReport = async (page : any, pageSize: any, fromDate: any, toDate: any, equipmentId: any, operatorId: any, location: any, sort : any , order:any) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/report/deviation?page=${page}&size=${pageSize}&order=${order}&sort=${sort}&status=&area_id=${location}&operator_id=${operatorId}&from_date_time=${fromDate}&to_date_time=${toDate}&equipment_id=${equipmentId}`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };

    const batchSummaryReport = async (page : any, pageSize: any, batchCode: any, activityType: any, area: any, sort : any , order:any) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_details_materialized_view?page=${page}&size=${pageSize}&order=${order}&sort=${sort}&status=active&keyword=&batch_number=${batchCode}&area_id=${area}&batch_id=&serial_number=&lot_id=&lot_code&master_activities_id=${activityType}&fingerdabbing_user_id=&operator_id=&fingerdabbing_guest_name=`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };


    const productionBatchSummaryReport = async (
  
  schedule_production_id: any,
  activityType: any,
  area: any,
) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/production/batch_report?status=active,inactive&schedule_production_id=${schedule_production_id}&is_completed=1`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


    const reportServices= {
        activeSamplingReport,
        passiveSamplingReport,
        personnelMonitoringReport,
        surfaceMonitoringReport,
        equipmentConfigurationReport,
        visualInspectionReport,
        plateSamplingReport,
        deviationReport,
        plateActivityReport,
        surfaceMonitoringListReport,
        batchSummaryReport,
        productionBatchSummaryReport,
        glovePortListReport,
        anaerobicReport,
        nitrogenReport,
        compressedAirReport
    };
  
    export { reportServices };